"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _hint = require("./hint.style");
const Hint = _ref => {
  let {
    hint,
    hintPosition = 'left'
  } = _ref;
  return (0, _jsxRuntime.jsx)(_hint.Components.HintText, (0, _extends2["default"])({
    hintPosition: hintPosition
  }, {
    children: hint
  }));
};
var _default = exports["default"] = Hint;